
const Track = () => {

  return (
    <div>
    
    <div className="flex flex-col justify-center  gap-1 max-w-[50rem] mx-auto lg:pl-[2rem] lg:pr-[2rem] lg:pt-[1rem] px-[1rem]">
      <h1 className="text-[20px] font-bold">Tracking</h1>
      <p>
        Whether you intend to move or relocate an online store, a supermarket or a steel plant, 
        TCS provides end-to-end inbound and outbound tracking services from the point of origin to 
        the venue of the event. This helps to identify the real-time location and other critical conditions 
        of in-transit cargo that may be of our customers’ concern.
      </p>
     

     
    </div>
  </div>
  );
};

export default Track;
